import { Link } from "react-router-dom";

/** Small footer shown at the bottom of every PUBLIC page (login, apply, sign, portal-login, privacy, terms). */
export default function PublicFooter() {
  return (
    <footer className="mt-12 pb-8 px-4 text-center text-[11px] text-slate-400 space-x-3" data-testid="public-footer">
      <span>© {new Date().getFullYear()} Unity Language Group</span>
      <span>·</span>
      <Link to="/privacy" className="hover:text-slate-700 underline" data-testid="footer-privacy">Privacy Policy</Link>
      <span>·</span>
      <Link to="/terms" className="hover:text-slate-700 underline" data-testid="footer-terms">Terms of Service</Link>
      <span>·</span>
      <a href="mailto:info@unitylanguagegroup.com" className="hover:text-slate-700 underline">info@unitylanguagegroup.com</a>
    </footer>
  );
}
